import { createMiniStore } from '@/utils/createMiniStore';
import { isFunction, uuidv4 } from '@/utils/util';
import { getDefaultAlertOptions } from './helper';

export default createMiniStore({
  // state
  state: {
    loading: [],
    popup: getDefaultAlertOptions(),
    longWork: [],
  },

  // commit
  mutations: {
    updateState: (state, payload) => {
      Object.entries(payload).forEach(([key, value]) => {
        if (state[key]) state[key] = value;
      });
    },
    // popup
    setPopup: (state, options = getDefaultAlertOptions()) => {
      state.popup = options;
    },
    // loading
    addLoading: (state, id) => {
      state.loading.push(id);
    },
    removeLoading: (state, id) => {
      const index = state.loading.findIndex(v => v == id);
      if (index != -1) state.loading.splice(index, 1);
    },
    hideLoading: state => {
      state.loading = [];
    },
    addLongWorkQueue: (state, { message, work, id }) => {
      state.longWork.push({ message, work, id });
    },
  },

  getters: {
    isLoading(state) {
      return !!state.loading.length;
    },
  },

  // dispath
  actions: {
    addLongWork: ({ commit, state }, message, work) =>
      new Promise((resolve, reject) => {
        const id = uuidv4();
        commit.addLongWorkQueue({
          message,
          id,
          work: async () => {
            try {
              let response;
              if (work instanceof Promise) response = await work;
              else response = await work();
              state.longWork.splice(
                state.longWork.findIndex(v => v.id == id),
                1,
              );
              resolve(response);
            } catch (error) {
              reject(error);
            }
          },
        });
      }),

    //popup
    popup: ({ commit }, options) => {
      commit.setPopup();
      if (!options) return;
      return new Promise(close => {
        commit.setPopup({
          ...options,
          onClose: isConfirm => {
            close(isConfirm);
            commit.setPopup();
            isConfirm &&
              isFunction(options?.callback) &&
              options.callback(options.param);
          },
        });
      });
    },
  },
});
